module.exports = __webpack_public_path__ + "img/img_person2_232px@3x.e455f0d8.png";